import * as Sentry from '@sentry/react';
import {hasValue} from '@kcast-fe/core';

import {APP_VARS} from '../constants';

const ERROR_LEVELS = ['error', 'fatal'];

const isErrorLevel = (level?: string): boolean => {
  return hasValue(level) && ERROR_LEVELS.includes(level);
};

export const setLoggerUser = (userId?: string) => {
  Sentry.setUser(userId ? {id: userId} : null);
};

/**
 * Init error-only logging. Must be called before the first React render.
 * Disabled when no API key is configured.
 */
export const initLogger = () => {
  Sentry.init({
    dsn: APP_VARS.SENTRY_DSN,
    enabled: APP_VARS.SENTRY_DSN.length > 0,
    release: APP_VARS.FE_VERSION,
    environment: APP_VARS.IS_DEV_ENV ? 'development' : 'production',
    defaultIntegrations: false,
    maxBreadcrumbs: 0,
    tracesSampleRate: 0,
    sendClientReports: false,
    beforeSend: (event) => (isErrorLevel(event.level) ? event : null),
    integrations: [
      Sentry.globalHandlersIntegration(),
      Sentry.linkedErrorsIntegration(),
      Sentry.dedupeIntegration()
    ]
  });
};
